import React, { useCallback } from 'react';
import { _cs } from '@togglecorp/fujs';
import InputLabel from '../InputLabel/index.js';
import InputError from '../InputError/index.js';
import InputHint from '../InputHint/index.js';
import List from '../List.js';
import Checkbox from '../Checkbox/index.js';
import { genericMemo } from '../../utils/index.js';
import styles from './styles.css.js';

const spacingToStyleMap = {
  none: styles.noSpacing,
  compact: styles.compactSpacing,
  comfortable: styles.comfortableSpacing,
  loose: styles.looseSpacing
};

function CheckListInput(props) {
  const {
    className,
    disabled,
    error,
    errorContainerClassName,
    hint,
    hintContainerClassName,
    label,
    labelContainerClassName,
    readOnly,
    uiMode,
    name,
    value,
    options,
    onChange,
    keySelector,
    labelSelector,
    checkboxClassName,
    listContainerClassName,
    spacing = 'comfortable',
    direction = 'horizontal'
  } = props;
  const handleCheck = useCallback((isSelected, key) => {
    if (isSelected) {
      onChange([...(value ?? []), key], name);
    } else {
      onChange([...(value ?? []).filter(v => v !== key)], name);
    }
  }, [value, onChange, name]);
  const optionListRendererParams = useCallback((key, data) => ({
    name: key,
    value: (value ?? []).some(v => v === key),
    onChange: handleCheck,
    label: labelSelector(data),
    uiMode,
    disabled,
    readOnly,
    spacing
  }), [value, handleCheck, labelSelector, uiMode, disabled, readOnly, spacing]);
  return /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.checkListInput, className, spacingToStyleMap[spacing], direction === 'horizontal' && styles.horizontal, direction === 'vertical' && styles.vertical)
  }, /*#__PURE__*/React.createElement(InputLabel, {
    className: labelContainerClassName,
    disabled: disabled
  }, label), /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.checkListContainer, listContainerClassName)
  }, /*#__PURE__*/React.createElement(List, {
    data: options,
    keySelector: keySelector,
    renderer: Checkbox,
    rendererParams: optionListRendererParams,
    rendererClassName: checkboxClassName
  })), /*#__PURE__*/React.createElement(InputError, {
    className: errorContainerClassName
  }, error), !error && hint && /*#__PURE__*/React.createElement(InputHint, {
    className: hintContainerClassName
  }, hint));
}

var index = genericMemo(CheckListInput);

export { index as default };
//# sourceMappingURL=index.js.map
